/**
 * Load the Auth0 user.
 *
 * @return {Promise}
 * @private
 */
const loadAuth0User = async (auth0Client, session) => {
  const [userError, user] = await new Promise((resolve) => {
    auth0Client.client.userInfo(session.accessToken, (...args) => resolve(args))
  })

  user.accessToken = session.accessToken

  return { user, userError }
}

export default loadAuth0User
